export const zIndex = {
  progressBar: 1000,
  modalOverlay: 2000,
} as const;
